import React from "react";

const DataViewDetailPanelToggle = ({
  detailPanelPosition,
  detailPanelPositions,
  onChange,
}) => {
  return (
    <div className="group relative w-full shrink-0 rounded-2xl border border-slate-800/80 bg-slate-950/70 p-1 shadow-[inset_0_1px_0_rgba(255,255,255,0.03)] sm:w-auto lg:max-w-md">
      <div className="mb-2 px-3 pt-2 text-[10px] font-semibold uppercase tracking-[0.2em] text-slate-500">
        Open Details As
      </div>

      <div className="pointer-events-none absolute bottom-full right-0 z-10 mb-3 w-64 rounded-2xl border border-sky-500/20 bg-slate-950/95 px-4 py-3 text-xs leading-5 text-sky-50 opacity-0 shadow-[0_12px_30px_rgba(2,6,23,0.45)] transition-all duration-200 group-hover:-translate-y-1 group-hover:opacity-100 group-focus-within:-translate-y-1 group-focus-within:opacity-100">
        Choose how the selected record details should appear.
      </div>

      <div className="grid grid-cols-1 gap-1 sm:grid-cols-2">
        <button
          type="button"
          onClick={() => onChange(detailPanelPositions.RIGHT)}
          className={`inline-flex min-h-[2.75rem] items-center justify-center rounded-xl px-4 text-sm font-semibold transition-all ${
            detailPanelPosition === detailPanelPositions.RIGHT
              ? "bg-sky-500/15 text-sky-100 shadow-[inset_0_0_0_1px_rgba(56,189,248,0.25)]"
              : "text-slate-300 hover:bg-slate-900 hover:text-white"
          }`}
        >
          Side Panel
        </button>

        <button
          type="button"
          onClick={() => onChange(detailPanelPositions.TOP)}
          className={`inline-flex min-h-[2.75rem] items-center justify-center rounded-xl px-4 text-sm font-semibold transition-all ${
            detailPanelPosition === detailPanelPositions.TOP
              ? "bg-sky-500/15 text-sky-100 shadow-[inset_0_0_0_1px_rgba(56,189,248,0.25)]"
              : "text-slate-300 hover:bg-slate-900 hover:text-white"
          }`}
        >
          Top Preview
        </button>
      </div>
    </div>
  );
};

export default DataViewDetailPanelToggle;
